import React from 'react';
import Question from './Question';
import './Quiz.css';

class QuestionList extends React.Component {

    constructor(props) {
        super(props);
        this.onAnswerChange = this.onAnswerChange.bind(this);
    }

    onAnswerChange(correct, i) {
        
        this.props.onSelect(correct, i);
    }

    render(){
      let { matches, onSubmit, onNext, correct } = this.props;

      let borderColor = null;
      let submitText = '';
      if (correct === 'correct') {
          borderColor = 'green';
          submitText = 'CORRECT!'
      } else if (correct === 'wrong') {
          borderColor = 'red';
          submitText = 'INCORRECT';
      }
  
      const answers = matches.map(item => item.color);
      return (
        <div className="question-container">
            <h1>Guess That Document</h1>
            <p>Try to match the colors on the left with the documents on the right.  To learn more about 
                the metrics, check out our <a href="https://medium.com/fathominfo/useful-document-summary-stats-13d99855b95e" target="_blank">blog post</a>.
            </p>
            <br></br>
            <span className="success-message" style={{color: borderColor ? borderColor : ''}}>{submitText}</span>
            <div className="quiz__body" style={{border: borderColor ? `2px solid ${borderColor}` : ''}}>
                <Question 
                    question={matches[0].doc.title} 
                    author={matches[0].doc.author}
                    answer={matches[0].color}
                    answers={answers} 
                    i={0}
                    selectHandler={this.onAnswerChange}></Question>
                <Question 
                    question={matches[1].doc.title} 
                    author={matches[1].doc.author}
                    answer={matches[1].color}
                    answers={answers}
                    i={1}
                    selectHandler={this.onAnswerChange}></Question>
                <Question 
                    question={matches[2].doc.title} 
                    author={matches[2].doc.author}
                    answer={matches[2].color}
                    answers={answers}
                    i={2}
                    selectHandler={this.onAnswerChange}></Question>
                <Question 
                    question={matches[3].doc.title} 
                    author={matches[3].doc.author}
                    answer={matches[3].color}
                    answers={answers}
                    i={3}
                    selectHandler={this.onAnswerChange}></Question>
                <button onClick={onSubmit}>Submit</button>
                <button onClick={onNext}>Next</button>
            </div>
        </div>);
    }
}

export default QuestionList;